import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { SiteAnnouncementsEntity } from './site-announcements.models'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'

@Injectable({
  providedIn: 'root',
})
export class SiteAnnouncementsApiService extends GbApiService {
  getSiteAnnouncements(limit: number, offset: number) {
    const url = `site-announcements/`
    const params = new HttpParams().set('limit', limit).set('offset', offset)
    return this.get<GbPaginatedResponse<SiteAnnouncementsEntity>>(url, {
      params,
    })
  }

  createSiteAnnouncement(siteAnnouncement: Partial<SiteAnnouncementsEntity>) {
    const url = `site-announcements/`
    return this.post<SiteAnnouncementsEntity>(url, siteAnnouncement)
  }

  updateSiteAnnouncement(siteAnnouncement: Partial<SiteAnnouncementsEntity>) {
    const url = `site-announcements/${siteAnnouncement.uuid}/`
    return this.patch<SiteAnnouncementsEntity>(url, siteAnnouncement)
  }

  deleteSiteAnnouncement(uuid: string) {
    const url = `site-announcements/${uuid}/`
    return this.delete<void>(url)
  }
}
